var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.821,
    height: 17,
    viewBox: "0 0 14.821 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-share-1736506",
    transform: "translate(-16 -963.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M27.987,963.362a2.837,2.837,0,0,0-2.7,3.705l-4.679,2.6a2.83,2.83,0,1,0,0,4.393l4.686,2.6a2.785,2.785,0,0,0-.143.865,2.849,2.849,0,1,0,.824-1.989l-4.557-2.534a2.816,2.816,0,0,0,.245-1.144,2.787,2.787,0,0,0-.245-1.144l4.55-2.534a2.833,2.833,0,1,0,2.016-4.822Zm0,1.308a1.526,1.526,0,1,1-1.526,1.526A1.516,1.516,0,0,1,27.987,964.67Zm-9.154,5.667a1.526,1.526,0,1,1-1.526,1.526A1.516,1.516,0,0,1,18.833,970.337ZM27.987,976a1.526,1.526,0,1,1-1.526,1.526A1.516,1.516,0,0,1,27.987,976Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.2c41da6c863f614a64ca0c507da92c5c.svg";
export { ForwardRef as ReactComponent };